export default {
  siteWidth: `960px`,
  contentWidth: `720px`,
}
